import { render, staticRenderFns } from "./ListPayoutsView.vue?vue&type=template&id=c51ab50a&"
import script from "./ListPayoutsView.vue?vue&type=script&lang=js&"
export * from "./ListPayoutsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports